<template>
    <!-- Admin → Cupones (/coupon). Mismo diseño que Admin → Usuarios (bkCuenta +
         cuentaMenu + usuariosAdmin.css) y cuponesAdmin.css (prefijo cp-).
         La lógica y los pedidos son los de siempre (CuponController, rutas
         /cupon fuera de /api/v1 con el middleware admin):
           GET  /cupon               lista
           POST /cupon               {code, percentage, status, days_of_week [7], quantity -1, selectedAccommodations}
           PUT  /cupon/{id}          el cupón completo + status 0/1 + selectedAccommodations
         `selectedAccommodations` va SIEMPRE: si falta, la API deja el cupón para
         todos los espacios. Los IDs elegibles salen de admin/get-accommodations/ids. -->
    <div class="cp-page">
        <div class="bk us cp">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_cupones.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_cupones.title_a') }} <span class="bk-grad">{{ $t('admin_cupones.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_cupones.sub') }}</p>

                <div class="us-stats" aria-live="polite">
                    <div class="us-stat"><span class="us-stat-n">{{ numero(cifras.total) }}</span><span class="us-stat-k">{{ $t('admin_cupones.stat.total') }}</span></div>
                    <button type="button" :class="['us-stat', { 'is-on': estado === 'on' }]" :aria-pressed="String(estado === 'on')" @click="cambiarEstado(estado === 'on' ? '' : 'on')">
                        <span class="us-stat-n">{{ numero(cifras.on) }}</span><span class="us-stat-k">{{ $t('admin_cupones.stat.on') }}</span>
                    </button>
                    <button type="button" :class="['us-stat', { 'is-on': estado === 'off' }]" :aria-pressed="String(estado === 'off')" @click="cambiarEstado(estado === 'off' ? '' : 'off')">
                        <span class="us-stat-n">{{ numero(cifras.off) }}</span><span class="us-stat-k">{{ $t('admin_cupones.stat.off') }}</span>
                    </button>
                    <div class="us-stat"><span class="us-stat-n">{{ numero(cifras.some) }}</span><span class="us-stat-k">{{ $t('admin_cupones.stat.some') }}</span></div>
                </div>

                <button type="button" class="bk-btn bk-btn--primary cp-new cp-new--side" @click="abrirForm(null)">
                    <span aria-hidden="true" v-html="IC.plus"></span>{{ $t('admin_cupones.new') }}
                </button>
            </aside>

            <section class="us-main cp-main" :aria-busy="String(cargando)">
                <div class="us-toolbar">
                    <div class="cp-toolbar-top">
                        <label class="us-search">
                            <span aria-hidden="true" v-html="IC.search"></span>
                            <span class="us-sr">{{ $t('admin_cupones.search_label') }}</span>
                            <input v-model="q" type="search" autocomplete="off" :placeholder="$t('admin_cupones.search_ph')" @input="pagina = 1" />
                        </label>
                        <button type="button" class="bk-btn bk-btn--primary cp-new cp-new--bar" @click="abrirForm(null)">
                            <span aria-hidden="true" v-html="IC.plus"></span>{{ $t('admin_cupones.new') }}
                        </button>
                    </div>
                    <div class="us-filter-row">
                        <div class="us-seg" role="group" :aria-label="$t('admin_cupones.seg.label')">
                            <button v-for="s in ESTADOS" :key="s || 'all'" type="button" :class="{ 'is-on': estado === s }" :aria-pressed="String(estado === s)" @click="cambiarEstado(s)">
                                {{ $t(`admin_cupones.seg.${s || 'all'}`) }}<span>{{ numero(s ? cifras[s] : cifras.total) }}</span>
                            </button>
                        </div>
                        <div class="us-selects">
                            <label class="us-sel"><span>{{ $t('admin_cupones.sort.label') }}</span>
                                <select v-model="orden" @change="pagina = 1">
                                    <option v-for="o in ORDENES" :key="o" :value="o">{{ $t(`admin_cupones.sort.${o}`) }}</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>

                <p v-if="!cargando && !error && cupones.length" class="cp-count" aria-live="polite">
                    {{ $tc('admin_cupones.results', filtrados.length, { n: numero(filtrados.length) }) }}
                    <button v-if="filtrando" type="button" class="us-link" @click="limpiar">{{ $t('admin_cupones.clear') }}</button>
                </p>

                <div v-if="cargando && !cupones.length" class="cp-loading"><HyFLoader variant="inline" /></div>
                <div v-else-if="error" class="us-empty">
                    <h3>{{ $t('admin_cupones.error_t') }}</h3>
                    <p>{{ $t('admin_cupones.error_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="cargar">{{ $t('admin_cupones.retry') }}</button>
                </div>
                <div v-else-if="!cupones.length" class="us-empty">
                    <h3>{{ $t('admin_cupones.none_t') }}</h3>
                    <p>{{ $t('admin_cupones.none_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--primary" @click="abrirForm(null)">{{ $t('admin_cupones.new') }}</button>
                </div>
                <div v-else-if="!filtrados.length" class="us-empty">
                    <h3>{{ $t('admin_cupones.empty_t') }}</h3>
                    <p>{{ $t('admin_cupones.empty_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="limpiar">{{ $t('admin_cupones.clear') }}</button>
                </div>

                <ul v-else class="cp-list">
                    <li v-for="c in pagina_" :key="c.id" :class="['cp-card', { 'is-off': !activo(c) }]">
                        <div class="cp-pct" aria-hidden="true">
                            <span class="cp-pct-n">{{ c.percentage }}<small>%</small></span>
                            <span class="cp-pct-k">{{ $t('admin_cupones.c.off_pct') }}</span>
                        </div>
                        <div class="cp-body">
                            <div class="cp-head">
                                <button type="button" class="cp-code" :title="$t('admin_cupones.c.copy', { c: codigo(c) })" :aria-label="$t('admin_cupones.c.copy', { c: codigo(c) })" @click="copiar(c)">
                                    <span class="cp-code-t">{{ codigo(c) }}</span><span aria-hidden="true" v-html="IC.copy"></span>
                                </button>
                                <span :class="['cp-badge', activo(c) ? 'cp-badge--on' : 'cp-badge--off']">{{ $t(activo(c) ? 'admin_cupones.c.active' : 'admin_cupones.c.inactive') }}</span>
                                <span class="us-sr">{{ c.percentage }}% {{ $t('admin_cupones.c.off_pct') }}</span>
                            </div>
                            <p class="cp-where">
                                <span aria-hidden="true" v-html="IC.home"></span>
                                <template v-if="!ids(c).length">{{ $t('admin_cupones.c.all_spaces') }}</template>
                                <template v-else>
                                    {{ $tc('admin_cupones.c.some_spaces', ids(c).length, { n: ids(c).length }) }}<template v-if="hostDe(c)"> {{ $t('admin_cupones.c.of_host', { n: hostDe(c) }) }}</template>:
                                    <span class="cp-ids">
                                        <a v-for="id in ids(c).slice(0, 4)" :key="id" class="cp-id" :href="`/alojamiento/${id}`" target="_blank" rel="noopener" :aria-label="$t('admin_cupones.c.open_space', { id })">#{{ id }}</a>
                                        <span v-if="ids(c).length > 4" class="cp-id cp-id--more">{{ $t('admin_cupones.c.more', { n: ids(c).length - 4 }) }}</span>
                                    </span>
                                </template>
                            </p>
                            <p class="cp-meta">
                                <span>{{ usos(c) }}</span><span>{{ dias(c) }}</span><span v-if="c.duration">{{ $t('admin_cupones.c.expires', { d: fecha(c.duration) }) }}</span>
                            </p>
                        </div>
                        <div class="cp-actions">
                            <button
                                type="button"
                                role="switch"
                                :class="['cp-switch', { 'is-on': activo(c) }]"
                                :aria-checked="String(activo(c))"
                                :aria-label="$t(activo(c) ? 'admin_cupones.c.toggle_off' : 'admin_cupones.c.toggle_on', { c: codigo(c) })"
                                :disabled="cambiando === c.id"
                                @click="alternar(c)"
                            ><span class="cp-switch-dot"></span></button>
                            <button type="button" class="bk-btn bk-btn--ghost cp-edit" @click="abrirForm(c, $event)">
                                <span aria-hidden="true" v-html="IC.edit"></span>{{ $t('admin_cupones.c.edit') }}
                            </button>
                        </div>
                    </li>
                </ul>

                <BkPaginacion :actual="pagina" :ultima="ultimaPagina" :total="filtrados.length" @ir="irAPagina" />
            </section>
        </div>

        <!-- Formulario (nuevo / editar) -->
        <div v-if="form" class="us-modal cp-modal" @keydown="teclaForm">
            <div class="us-modal-bg" @click="cerrarForm"></div>
            <form ref="formCard" class="us-modal-card cp-form" role="dialog" aria-modal="true" aria-labelledby="cp-f-title" novalidate @submit.prevent="guardar">
                <div class="cp-form-head">
                    <h2 id="cp-f-title">{{ form.id ? $t('admin_cupones.f.edit_t') : $t('admin_cupones.f.new_t') }}</h2>
                    <button type="button" class="cp-x" :aria-label="$t('admin_cupones.f.cancel')" @click="cerrarForm"><span aria-hidden="true" v-html="IC.x"></span></button>
                </div>

                <fieldset class="cp-fs" :disabled="guardando">
                    <label :class="['us-field', { 'is-invalid': err.code }]">
                        <span class="us-field-l">{{ $t('admin_cupones.f.code') }}</span>
                        <input ref="codigo" v-model="form.code" type="text" maxlength="60" autocomplete="off" spellcheck="false" class="us-mono" :disabled="!!form.id" :aria-invalid="err.code ? 'true' : null" @input="limpiarErr('code')" />
                        <span v-if="err.code" class="us-field-e">{{ err.code }}</span>
                        <span v-else class="us-field-h">{{ $t(form.id ? 'admin_cupones.f.code_locked' : 'admin_cupones.f.code_h') }}</span>
                    </label>

                    <div :class="['us-field', { 'is-invalid': err.percentage }]">
                        <label class="us-field-l" for="cp-pct">{{ $t('admin_cupones.f.pct') }}</label>
                        <div class="cp-pct-row">
                            <span class="cp-pct-in">
                                <input id="cp-pct" v-model="form.percentage" type="number" inputmode="numeric" min="0" max="100" step="1" :aria-invalid="err.percentage ? 'true' : null" @input="limpiarErr('percentage')" />
                                <span aria-hidden="true">%</span>
                            </span>
                            <div class="us-seg us-seg--sm" role="group" :aria-label="$t('admin_cupones.f.pct')">
                                <button v-for="n in RAPIDOS" :key="n" type="button" :class="{ 'is-on': Number(form.percentage) === n && form.percentage !== '' }" @click="form.percentage = n; limpiarErr('percentage')">{{ n }}%</button>
                            </div>
                        </div>
                        <span v-if="err.percentage" class="us-field-e">{{ err.percentage }}</span>
                        <span v-else class="us-field-h">{{ $t('admin_cupones.f.pct_h') }}</span>
                    </div>

                    <fieldset :class="['us-field', { 'is-invalid': err.ids }]">
                        <legend class="us-field-l">{{ $t('admin_cupones.f.where') }}</legend>
                        <div class="us-seg us-seg--sm">
                            <label :class="{ 'is-on': !form.algunos }"><input v-model="form.algunos" type="radio" :value="false" name="cp-where" @change="limpiarErr('ids')" />{{ $t('admin_cupones.f.where_all') }}</label>
                            <label :class="{ 'is-on': form.algunos }"><input v-model="form.algunos" type="radio" :value="true" name="cp-where" @change="alElegirHost" />{{ $t('admin_cupones.f.where_some') }}</label>
                        </div>

                        <div v-if="form.algunos" class="cp-host-box">
                            <p v-if="form.legado && !form.anfitrion" class="us-note us-note--warn"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_cupones.f.legacy_multi', { n: form.legado.nombres }) }}</span></p>

                            <!-- 1. Anfitrión -->
                            <p v-if="cargandoHost && !form.anfitrion" class="us-field-h" aria-live="polite">{{ $t('admin_cupones.f.host_loading') }}</p>
                            <div v-else-if="!form.anfitrion" class="cp-host-search">
                                <label class="us-sr" for="cp-host-q">{{ $t('admin_cupones.f.host') }}</label>
                                <span class="cp-host-q">
                                    <span aria-hidden="true" v-html="IC.search"></span>
                                    <input
                                        id="cp-host-q"
                                        ref="hostIn"
                                        v-model="hostQ"
                                        type="search"
                                        autocomplete="off"
                                        role="combobox"
                                        aria-autocomplete="list"
                                        aria-controls="cp-host-list"
                                        :aria-expanded="String(hostRes.length > 0)"
                                        :aria-activedescendant="hostIdx >= 0 ? `cp-host-o-${hostIdx}` : null"
                                        :placeholder="$t('admin_cupones.f.host_ph')"
                                        @input="buscarHost"
                                        @keydown="teclaHost"
                                    />
                                </span>
                                <ul v-if="hostRes.length" id="cp-host-list" class="cp-host-list" role="listbox" :aria-label="$t('admin_cupones.f.host')">
                                    <li
                                        v-for="(h, i) in hostRes"
                                        :id="`cp-host-o-${i}`"
                                        :key="h.idusuario"
                                        role="option"
                                        :aria-selected="String(i === hostIdx)"
                                        :class="['cp-host-opt', { 'is-on': i === hostIdx }]"
                                        @mousedown.prevent="elegirHost(h)"
                                        @mouseenter="hostIdx = i"
                                    >
                                        <span class="cp-host-av" aria-hidden="true">{{ iniciales(h.nombre) }}</span>
                                        <span class="cp-host-txt">
                                            <b>{{ h.nombre || `#${h.idusuario}` }}</b>
                                            <small>{{ [h.correo, h.telefono].filter(Boolean).join(' · ') }}</small>
                                        </span>
                                        <span class="cp-host-n">{{ $tc('admin_cupones.f.host_spaces', h.espacios, { n: h.espacios }) }}</span>
                                    </li>
                                </ul>
                                <p v-else class="us-field-h" aria-live="polite">{{ hostMsg }}</p>
                            </div>

                            <!-- 2. Sus espacios -->
                            <template v-else>
                                <div class="cp-host-card">
                                    <span class="cp-host-av" aria-hidden="true">{{ iniciales(form.anfitrion.nombre) }}</span>
                                    <span class="cp-host-txt">
                                        <b>{{ form.anfitrion.nombre || `#${form.anfitrion.idusuario}` }}</b>
                                        <small>{{ [form.anfitrion.correo, form.anfitrion.telefono].filter(Boolean).join(' · ') }}</small>
                                    </span>
                                    <button type="button" class="us-link" @click="cambiarHost">{{ $t('admin_cupones.f.host_change') }}</button>
                                </div>
                                <div v-if="cargandoHost" class="us-field-h">{{ $t('admin_cupones.f.host_loading') }}</div>
                                <template v-else>
                                    <div class="us-seg us-seg--sm" role="radiogroup" :aria-label="$t('admin_cupones.f.where')">
                                        <label :class="{ 'is-on': form.todosHost }"><input v-model="form.todosHost" type="radio" :value="true" name="cp-scope" @change="limpiarErr('ids')" />{{ $t('admin_cupones.f.scope_all', { n: form.espacios.length }) }}</label>
                                        <label :class="{ 'is-on': !form.todosHost }"><input v-model="form.todosHost" type="radio" :value="false" name="cp-scope" />{{ $t('admin_cupones.f.scope_some') }}</label>
                                    </div>
                                    <p v-if="form.todosHost" class="us-field-h">{{ $t('admin_cupones.f.snapshot_h') }}</p>
                                    <div v-else class="cp-spaces">
                                        <input v-if="form.espacios.length > 6" v-model="espQ" type="search" class="cp-spaces-q" autocomplete="off" :placeholder="$t('admin_cupones.f.spaces_filter')" :aria-label="$t('admin_cupones.f.spaces_filter')" @keydown.enter.prevent />
                                        <ul class="cp-spaces-list">
                                            <li v-for="e in espaciosVisibles" :key="e.idalojamiento">
                                                <label :class="['cp-space', { 'is-on': form.sel.includes(e.idalojamiento) }]">
                                                    <input v-model="form.sel" type="checkbox" :value="e.idalojamiento" @change="limpiarErr('ids')" />
                                                    <span class="cp-space-txt" :title="e.nombre">
                                                        <span class="cp-space-ids">
                                                            <span class="cp-pill">{{ $t('admin_cupones.f.space_id', { id: e.idalojamiento }) }}</span>
                                                            <span v-if="e.codigo" class="cp-pill cp-pill--code">{{ $t('admin_cupones.f.space_code', { c: e.codigo }) }}</span>
                                                            <span v-else class="cp-pill cp-pill--none">{{ $t('admin_cupones.f.no_code') }}</span>
                                                            <em v-if="!e.aprobado" class="cp-space-rev">{{ $t('admin_cupones.f.review') }}</em>
                                                        </span>
                                                        <small>{{ e.direccion || $t('admin_cupones.f.no_address') }}</small>
                                                    </span>
                                                </label>
                                            </li>
                                        </ul>
                                        <p class="us-field-h">{{ $tc('admin_cupones.f.selected', form.sel.length, { n: form.sel.length }) }}</p>
                                    </div>
                                </template>
                                <p v-if="form.fuera.length" class="us-note"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_cupones.f.legacy_gone', { ids: form.fuera.map(i => `#${i}`).join(', ') }) }}</span></p>
                            </template>
                        </div>
                        <span v-if="err.ids" class="us-field-e" role="alert">{{ err.ids }}</span>
                    </fieldset>

                    <div class="us-field">
                        <span class="us-field-l">{{ $t('admin_cupones.f.status') }}</span>
                        <button type="button" role="switch" :class="['cp-switch-row']" :aria-checked="String(form.status)" @click="form.status = !form.status">
                            <span :class="['cp-switch', { 'is-on': form.status }]" aria-hidden="true"><span class="cp-switch-dot"></span></span>
                            <span>{{ $t(form.status ? 'admin_cupones.f.status_on' : 'admin_cupones.f.status_off') }}</span>
                        </button>
                    </div>
                </fieldset>

                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" :disabled="guardando" @click="cerrarForm">{{ $t('admin_cupones.f.cancel') }}</button>
                    <button type="submit" class="bk-btn bk-btn--primary" :disabled="guardando || cargandoHost || (form.id && !formCambios)">
                        <span v-if="guardando" class="bk-spinner"></span>{{ $t(guardando ? 'admin_cupones.f.saving' : form.id ? 'admin_cupones.f.save' : 'admin_cupones.f.create') }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Confirmación -->
        <div v-if="modal" class="us-modal">
            <div class="us-modal-bg" @click="responderModal(false)"></div>
            <div ref="modalCard" class="us-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="cp-m-title" aria-describedby="cp-m-text" @keydown="teclaModal">
                <h2 id="cp-m-title">{{ modal.titulo }}</h2>
                <p id="cp-m-text">{{ modal.texto }}</p>
                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="responderModal(false)">{{ $t('admin_cupones.k.cancel') }}</button>
                    <button ref="modalOk" type="button" :class="['bk-btn', modal.peligro ? 'us-btn--danger' : 'bk-btn--primary']" @click="responderModal(true)">{{ modal.ok }}</button>
                </div>
            </div>
        </div>

        <transition name="us-toast">
            <div v-if="aviso" :class="['us-toast', `us-toast--${aviso.tipo}`]" role="status" aria-live="polite">
                <span class="us-toast-ico" aria-hidden="true">{{ aviso.tipo === 'ok' ? '✓' : '!' }}</span><span>{{ aviso.txt }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import BkPaginacion from '@/components/Cuenta/BkPaginacion.vue';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
// Íconos: texto fijo de este archivo, nunca datos del usuario.
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    x: P('<path d="M18 6 6 18M6 6l12 12"/>'),
    search: ICON.search, plus: ICON.plus, copy: ICON.copy, edit: ICON.edit, home: ICON.home,
    warn: P('<path d="M12 3 2 20h20z"/><path d="M12 10v4M12 17h.01"/>'),
    info: P('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
};
const ESTADOS = ['', 'on', 'off'];
const ORDENES = ['new', 'code', 'pct'];
const RAPIDOS = [5, 10, 15, 20, 25];
const POR_PAGINA = 12;
const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };

// Igual que antes: la API vive en VUE_APP_API_URL sin el /api/v1.
const base = () => {
    const u = process.env.VUE_APP_API_URL || '';
    const i = u.indexOf('/api/v1');
    return i === -1 ? u.replace(/\/+$/, '') : u.substring(0, i);
};
// alojamiento_ids llega como [{ idalojamiento }] (accessor del modelo).
const idsDe = c => (Array.isArray(c.alojamiento_ids) ? c.alojamiento_ids : [])
    .map(x => Number(x && typeof x === 'object' ? x.idalojamiento : x)).filter(n => n > 0);
const api = p => `${process.env.VUE_APP_API_URL}admin/cupones/${p}`;
const mismoConjunto = (a, b) => a.length === b.length && a.every(x => b.includes(x));

export default {
    name: 'AdminCupones',
    components: { BkPaginacion, HyFLoader },
    data() {
        return {
            IC, ESTADOS, ORDENES, RAPIDOS,
            cupones: [], cargando: true, error: false,
            q: '', estado: '', orden: 'new', pagina: 1,
            cambiando: null,
            form: null, original: null, err: {}, guardando: false,
            // Anfitrión del formulario: búsqueda, resultados y sus espacios.
            hostQ: '', hostRes: [], hostIdx: -1, hostBuscando: false, hostBuscado: '', cargandoHost: false, espQ: '',
            // Dueño de cada espacio de los cupones de la lista (para "de Juan Pérez").
            duenos: { espacios: {}, anfitriones: {} },
            modal: null, aviso: null,
        };
    },
    computed: {
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        cifras() {
            const on = this.cupones.filter(c => this.activo(c)).length;
            return { total: this.cupones.length, on, off: this.cupones.length - on, some: this.cupones.filter(c => idsDe(c).length).length };
        },
        filtrando() { return !!(this.q.trim() || this.estado || this.orden !== 'new'); },
        filtrados() {
            const t = this.q.trim().toLowerCase().replace(/^#/, '');
            let l = this.cupones.filter(c => !this.estado || (this.estado === 'on') === this.activo(c));
            if (t) l = l.filter(c => this.codigo(c).toLowerCase().includes(t) || (/^\d+$/.test(t) && idsDe(c).some(id => String(id) === t)));
            const por = {
                new: (a, b) => b.id - a.id,
                code: (a, b) => this.codigo(a).localeCompare(this.codigo(b), this.loc, { sensitivity: 'base' }),
                pct: (a, b) => b.percentage - a.percentage || b.id - a.id,
            }[this.orden];
            return l.slice().sort(por);
        },
        ultimaPagina() { return Math.max(1, Math.ceil(this.filtrados.length / POR_PAGINA)); },
        pagina_() { return this.filtrados.slice((this.pagina - 1) * POR_PAGINA, this.pagina * POR_PAGINA); },
        // IDs que se guardan según lo elegido en "Dónde vale".
        idsFinales() {
            const f = this.form;
            if (!f || !f.algunos) return [];
            if (!f.anfitrion) return f.legado ? f.legado.ids.slice() : [];
            return f.todosHost ? f.espacios.map(e => e.idalojamiento) : f.espacios.map(e => e.idalojamiento).filter(id => f.sel.includes(id));
        },
        espaciosVisibles() {
            const f = this.form;
            if (!f) return [];
            const t = this.espQ.trim().toLowerCase().replace(/^#/, '');
            if (!t) return f.espacios;
            return f.espacios.filter(e => String(e.idalojamiento).includes(t) || `${e.nombre} ${e.direccion || ''} ${e.codigo || ''}`.toLowerCase().includes(t));
        },
        hostMsg() {
            const t = this.hostQ.trim();
            if (t.length < 2) return this.$t('admin_cupones.f.host_min');
            if (this.hostBuscando || this.hostBuscado !== t) return this.$t('admin_cupones.f.host_searching');
            return this.$t('admin_cupones.f.host_none');
        },
        formCambios() {
            if (!this.form || !this.original) return false;
            const f = this.form, o = this.original;
            return String(f.code) !== String(o.code) || String(f.percentage) !== String(o.percentage) || f.status !== o.status
                || !mismoConjunto(this.idsFinales, o.ids);
        },
    },
    watch: {
        ultimaPagina(n) { if (this.pagina > n) this.pagina = n; },
    },
    created() {
        this._avisoT = null;
        this.cargar();
    },
    beforeDestroy() {
        clearTimeout(this._avisoT);
        document.documentElement.classList.remove('us-locked');
    },
    methods: {
        // ── Datos ────────────────────────────────────────────────────────
        async cargar() {
            this.cargando = true;
            this.error = false;
            try {
                const { data } = await axios.get(`${base()}/cupon`);
                this.cupones = Array.isArray(data) ? data : [];
                this.cargarDuenos();
            } catch (e) {
                console.error('[Cupones] No se pudieron cargar', e);
                this.error = true;
            } finally {
                this.cargando = false;
            }
        },
        // De quién son los espacios de los cupones (un solo pedido para toda la lista).
        async cargarDuenos(ids) {
            const todos = ids || [...new Set([].concat(...this.cupones.map(idsDe)))];
            if (!todos.length) return { espacios: {}, anfitriones: {} };
            try {
                const { data } = await axios.get(api('duenos'), { params: { ids: todos.join(',') } });
                if (!ids) this.duenos = data;
                return data;
            } catch (e) {
                console.error('[Cupones] Dueños de los espacios', e);
                return null;
            }
        },
        // Nombre del anfitrión si todos los espacios del cupón son de la misma persona.
        hostDe(c) {
            const dueños = [...new Set(idsDe(c).map(id => (this.duenos.espacios[id] || {}).idusuario).filter(Boolean))];
            if (dueños.length !== 1) return '';
            const h = this.duenos.anfitriones[dueños[0]];
            return h ? (h.nombre || `#${h.idusuario}`) : '';
        },
        iniciales(n) {
            const p = String(n || '?').trim().split(/\s+/);
            return ((p[0] || '?')[0] + (p[1] ? p[1][0] : '')).toUpperCase();
        },

        // ── Formato ──────────────────────────────────────────────────────
        numero(n) { return Number(n || 0).toLocaleString(this.loc); },
        activo(c) { return Number(c.status) === 1 || c.status === true; },
        codigo(c) { return String(c.code || '').trim(); },
        ids(c) { return idsDe(c); },
        fecha(s) {
            const d = new Date(`${String(s).slice(0, 10)}T00:00:00`);
            return isNaN(d.getTime()) ? s : d.toLocaleDateString(this.loc, { day: 'numeric', month: 'short', year: 'numeric' });
        },
        usos(c) {
            const q = Number(c.quantity);
            return q === -1 ? this.$t('admin_cupones.c.unlimited') : this.$tc('admin_cupones.c.uses', q, { n: this.numero(q) });
        },
        // days_of_week: 7 = todos; 0–6 = domingo a sábado (Carbon::weekday()).
        dias(c) {
            const d = Array.isArray(c.days_of_week) ? c.days_of_week.map(Number) : [7];
            if (!d.length || d.includes(7)) return this.$t('admin_cupones.c.all_days');
            const nombre = n => new Date(2024, 0, 7 + n).toLocaleDateString(this.loc, { weekday: 'short' });
            return this.$t('admin_cupones.c.days', { d: d.slice().sort().map(nombre).join(', ') });
        },

        // ── Filtros ──────────────────────────────────────────────────────
        cambiarEstado(s) { this.estado = s; this.pagina = 1; },
        limpiar() { this.q = ''; this.estado = ''; this.orden = 'new'; this.pagina = 1; },
        irAPagina(p) {
            this.pagina = p;
            this.$nextTick(() => { const el = this.$el.querySelector('.us-toolbar'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },
        async copiar(c) {
            try { await navigator.clipboard.writeText(this.codigo(c)); this.avisar(this.$t('admin_cupones.c.copied'), 'ok'); } catch (e) { this.avisar(this.$t('admin_cupones.c.copy_fail'), 'error'); }
        },

        // ── Activar / desactivar desde la lista (mismo PUT que el formulario) ──
        async alternar(c) {
            if (this.cambiando) return;
            const nuevo = !this.activo(c);
            if (!nuevo && !(await this.confirmar({
                titulo: this.$t('admin_cupones.k.off_t'), texto: this.$t('admin_cupones.k.off_p', { c: this.codigo(c) }), ok: this.$t('admin_cupones.k.off_ok'), peligro: true,
            }))) return;
            this.cambiando = c.id;
            try {
                await axios.put(`${base()}/cupon/${c.id}`, this.cuerpoUpdate(c, { status: nuevo ? 1 : 0, ids: idsDe(c) }));
                c.status = nuevo ? 1 : 0;
                this.avisar(this.$t(nuevo ? 'admin_cupones.toast.on' : 'admin_cupones.toast.off', { c: this.codigo(c) }), 'ok');
            } catch (e) {
                console.error('[Cupones] No se pudo cambiar el estado', e);
                this.avisar(this.$t('admin_cupones.toast.error'), 'error');
            } finally {
                this.cambiando = null;
            }
        },
        // Lo mismo que mandaba CouponFormUpdate: el cupón completo, status 0/1
        // y la lista de espacios como [{ idalojamiento }].
        cuerpoUpdate(c, { percentage, status, ids }) {
            const body = { ...c, status, selectedAccommodations: ids.map(id => ({ idalojamiento: id })) };
            if (percentage !== undefined) body.percentage = percentage;
            return body;
        },

        // ── Formulario ───────────────────────────────────────────────────
        abrirForm(c, ev) {
            this._foco = (ev && ev.currentTarget) || document.activeElement;
            const ids = c ? idsDe(c) : [];
            this.form = {
                id: c ? c.id : null, code: c ? c.code : '', percentage: c ? String(c.percentage) : '', status: c ? this.activo(c) : true,
                algunos: ids.length > 0,
                // Anfitrión elegido y sus espacios; todosHost = "todos sus espacios".
                anfitrion: null, espacios: [], todosHost: true, sel: [],
                // Espacios que tenía el cupón y no son de este anfitrión o ya no están publicados.
                fuera: [], legado: null,
            };
            this.original = { code: this.form.code, percentage: this.form.percentage, status: this.form.status, ids: ids.slice() };
            this.err = {};
            this.hostQ = ''; this.hostRes = []; this.hostIdx = -1; this.espQ = '';
            document.documentElement.classList.add('us-locked');
            if (ids.length) this.precargarHost(ids);
            this.$nextTick(() => {
                const el = c ? this.$el.querySelector('#cp-pct') : this.$refs.codigo;
                if (el) el.focus();
            });
        },
        // Cupón ya creado: se busca de quién son sus espacios. Si son de una sola
        // persona queda elegida (con "todos sus espacios" si los tiene todos).
        // Si son de varias, se avisa y se conservan tal cual mientras no se elija otro.
        async precargarHost(ids) {
            this.cargandoHost = true;
            const d = await this.cargarDuenos(ids);
            if (!this.form) return;
            const dueños = d ? [...new Set(ids.map(id => (d.espacios[id] || {}).idusuario).filter(Boolean))] : [];
            if (dueños.length === 1) {
                await this.elegirHost(d.anfitriones[dueños[0]], ids);
            } else {
                this.form.legado = { ids, nombres: dueños.map(u => (d.anfitriones[u] || {}).nombre || `#${u}`).join(', ') || ids.map(i => `#${i}`).join(', ') };
                this.cargandoHost = false;
            }
        },
        alElegirHost() {
            this.limpiarErr('ids');
            if (!this.form.anfitrion) this.$nextTick(() => { if (this.$refs.hostIn) this.$refs.hostIn.focus(); });
        },
        buscarHost() {
            clearTimeout(this._hostT);
            this.hostIdx = -1;
            const t = this.hostQ.trim();
            if (t.length < 2) { this.hostRes = []; return; }
            this._hostT = setTimeout(async () => {
                const req = (this._hostReq = (this._hostReq || 0) + 1);
                this.hostBuscando = true;
                try {
                    const { data } = await axios.get(api('anfitriones'), { params: { q: t } });
                    if (req !== this._hostReq) return;
                    this.hostRes = data.data || [];
                    this.hostBuscado = t;
                    this.hostIdx = this.hostRes.length ? 0 : -1;
                } catch (e) {
                    if (req === this._hostReq) { this.hostRes = []; this.hostBuscado = t; this.avisar(this.$t('admin_cupones.f.host_error'), 'error'); }
                } finally {
                    if (req === this._hostReq) this.hostBuscando = false;
                }
            }, 280);
        },
        teclaHost(e) {
            const n = this.hostRes.length;
            if (e.key === 'ArrowDown' && n) { e.preventDefault(); this.hostIdx = (this.hostIdx + 1) % n; }
            else if (e.key === 'ArrowUp' && n) { e.preventDefault(); this.hostIdx = (this.hostIdx - 1 + n) % n; }
            else if (e.key === 'Enter') { e.preventDefault(); if (this.hostRes[this.hostIdx]) this.elegirHost(this.hostRes[this.hostIdx]); }
            else if (e.key === 'Escape' && (this.hostQ || n)) { e.preventDefault(); e.stopPropagation(); this.hostQ = ''; this.hostRes = []; }
        },
        // previos: los espacios que ya tenía el cupón (al editar).
        async elegirHost(h, previos) {
            if (!h || !this.form) return;
            const f = this.form;
            f.anfitrion = { idusuario: h.idusuario, nombre: h.nombre, correo: h.correo, telefono: h.telefono };
            this.hostRes = []; this.hostQ = ''; this.espQ = '';
            this.limpiarErr('ids');
            this.cargandoHost = true;
            try {
                const { data } = await axios.get(api(`anfitriones/${h.idusuario}`));
                if (this.form !== f) return;
                f.espacios = data.espacios || [];
                const suyos = f.espacios.map(e => e.idalojamiento);
                const prev = previos || [];
                f.fuera = prev.filter(id => !suyos.includes(id));
                const dentro = prev.filter(id => suyos.includes(id));
                f.todosHost = !prev.length || (suyos.length > 0 && mismoConjunto(dentro, suyos));
                f.sel = f.todosHost ? [] : dentro;
            } catch (e) {
                if (this.form === f) { f.anfitrion = null; this.avisar(this.$t('admin_cupones.f.host_error'), 'error'); }
            } finally {
                this.cargandoHost = false;
            }
        },
        cambiarHost() {
            const f = this.form;
            // Lo que estaba elegido de este anfitrión deja de contar; si el cupón
            // traía espacios de otros, vuelve el aviso.
            f.anfitrion = null; f.espacios = []; f.sel = []; f.todosHost = true; f.fuera = [];
            this.$nextTick(() => { if (this.$refs.hostIn) this.$refs.hostIn.focus(); });
        },
        async cerrarForm() {
            if (this.guardando) return;
            if ((this.form.id ? this.formCambios : this.hayAlgo()) && !(await this.confirmar({
                titulo: this.$t('admin_cupones.k.leave_t'), texto: this.$t('admin_cupones.k.leave_p'), ok: this.$t('admin_cupones.k.leave_ok'), peligro: true,
            }))) return;
            this.form = null;
            this.original = null;
            document.documentElement.classList.remove('us-locked');
            const el = this._foco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
        },
        hayAlgo() { const f = this.form; return !!(f && (String(f.code).trim() || String(f.percentage) !== '' || f.anfitrion)); },
        limpiarErr(k) { if (this.err[k]) this.$delete(this.err, k); },
        validar() {
            const f = this.form, e = {}, t = k => this.$t(`admin_cupones.f.err_${k}`);
            const code = String(f.code || '').trim();
            if (!f.id) {
                if (!code) e.code = t('code');
                else if (/\s/.test(code)) e.code = t('code_spaces');
                else if (this.cupones.some(c => this.codigo(c).toLowerCase() === code.toLowerCase())) e.code = t('code_taken');
            }
            const p = String(f.percentage).trim();
            if (!/^\d{1,3}$/.test(p) || Number(p) > 100) e.percentage = t('pct');
            if (f.algunos && !f.anfitrion && !f.legado) e.ids = t('host');
            else if (f.algunos && f.anfitrion && !this.cargandoHost && !this.idsFinales.length) e.ids = t('spaces');
            return e;
        },
        async guardar() {
            if (this.guardando || !this.form) return;
            if (this.cargandoHost) return;
            const e = this.validar();
            this.err = e;
            if (Object.keys(e).length) {
                this.avisar(this.$t('admin_cupones.f.err_generic'), 'error');
                this.$nextTick(() => { const el = this.$el.querySelector('.cp-form .us-field.is-invalid input:not([type=radio]):not([type=checkbox])'); if (el) el.focus(); });
                return;
            }
            const f = this.form;
            const ids = this.idsFinales.slice();
            const pct = Number(f.percentage);
            this.guardando = true;
            try {
                if (f.id) {
                    const c = this.cupones.find(x => x.id === f.id);
                    await axios.put(`${base()}/cupon/${f.id}`, this.cuerpoUpdate(c, { percentage: pct, status: f.status ? 1 : 0, ids }));
                    this.avisar(this.$t('admin_cupones.toast.saved', { c: this.codigo(c) }), 'ok');
                } else {
                    const code = String(f.code).trim();
                    await axios.post(`${base()}/cupon`, {
                        code, percentage: pct, status: f.status ? 1 : 0, days_of_week: [7], quantity: -1,
                        selectedAccommodations: ids.map(id => ({ idalojamiento: id })),
                    });
                    this.avisar(this.$t('admin_cupones.toast.created', { c: code }), 'ok');
                    this.limpiar();
                }
                this.guardando = false;
                this.form = null;
                this.original = null;
                document.documentElement.classList.remove('us-locked');
                const el = this._foco;
                await this.cargar();
                this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            } catch (err) {
                this.guardando = false;
                const r = err.response;
                const d = r && r.data;
                if (r && r.status === 422 && d) {
                    const m = {};
                    if (d.code) m.code = /taken|unique/i.test(String(d.code[0] || '')) ? this.$t('admin_cupones.f.err_code_taken') : this.$t('admin_cupones.f.err_code');
                    if (d.percentage) m.percentage = this.$t('admin_cupones.f.err_pct');
                    this.err = m;
                    this.avisar(this.$t('admin_cupones.f.err_generic'), 'error');
                } else {
                    console.error('[Cupones] No se pudo guardar', err);
                    this.avisar(this.$t('admin_cupones.toast.error'), 'error');
                }
            }
        },
        // Esc cierra y el Tab no sale del formulario.
        teclaForm(e) {
            if (this.modal) return;
            if (e.key === 'Escape') { e.preventDefault(); this.cerrarForm(); return; }
            this.atrapar(e, this.$refs.formCard);
        },
        teclaModal(e) {
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.responderModal(false); return; }
            this.atrapar(e, this.$refs.modalCard);
        },
        atrapar(e, cont) {
            if (e.key !== 'Tab' || !cont) return;
            const els = Array.from(cont.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled)')).filter(x => x.offsetParent !== null);
            if (!els.length) return;
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },

        // ── Confirmación y aviso ─────────────────────────────────────────
        confirmar({ titulo, texto, ok, peligro }) {
            return new Promise(resolve => {
                this._modalFoco = document.activeElement;
                this.modal = { titulo, texto, ok, peligro: !!peligro, resolve };
                this.$nextTick(() => { if (this.$refs.modalOk) this.$refs.modalOk.focus(); });
            });
        },
        responderModal(v) {
            if (!this.modal) return;
            const { resolve } = this.modal;
            this.modal = null;
            const el = this._modalFoco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            resolve(v);
        },
        avisar(txt, tipo) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, tipo: tipo || 'ok' };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3200);
        },
    },
};
</script>

<style src="../../components/BankInformation/bkCuenta.css"></style>
<style src="../../components/Cuenta/cuentaMenu.css"></style>
<style src="../../components/Admin/Usuarios/usuariosAdmin.css"></style>
<style src="../../components/CouponForm/cuponesAdmin.css"></style>
